// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__nq5Xu","head":"Table_head__29b3h","col":"Table_col__6nigi"};